import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";

export const Route = createFileRoute("/location/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [location, setLocation] = useState<{ lat: number; lng: number } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by this browser.");
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setLoading(false);
      },
      (error) => {
        let errorMessage = "Unknown error occurred";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Location permission denied by user.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Location information is unavailable.";
            break;
          case error.TIMEOUT:
            errorMessage = "Location request timed out.";
            break;
        }
        setError(errorMessage);
        setLoading(false);
      },
    );
  }, []);

  return (
    <div className="mx-auto max-w-md p-1 sm:p-8">
      <h1 className="mb-6 text-2xl font-bold">Location Tracker</h1>

      {loading && (
        <div className="text-center">
          <p>Requesting location permission...</p>
        </div>
      )}

      {error && (
        <div className="mt-4 rounded border border-red-400 bg-red-100 p-4 text-red-700">
          {error}
        </div>
      )}

      {location && (
        <div className="mt-6 rounded border border-green-400 bg-green-100 p-4 text-green-700">
          <h2 className="mb-2 font-semibold">Your Location:</h2>
          <p>
            <strong>Latitude:</strong> {location.lat}
          </p>
          <p>
            <strong>Longitude:</strong> {location.lng}
          </p>
        </div>
      )}
    </div>
  );
}
